module.exports = __webpack_public_path__ + "icons/original/large/large-f5.23ad85abc671b650c4fab087327177b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-f5.png
// module id = t+UZ
// module chunks = app